import {getAssetUrl} from '@Utils/s3.util';

const FULL_LOGO_FILENAME = 'logo-postermaker.svg';
const COMPACT_LOGO_FILENAME = 'logo-mobile.svg';

/**
 * Resolves the PosterMyWall brand logo URL
 * @param showFullLogo true for the full wordmark, false for the compact mark.
 */
export function getPmwLogoUrl(showFullLogo: boolean): string {
  return getAssetUrl(showFullLogo ? FULL_LOGO_FILENAME : COMPACT_LOGO_FILENAME);
}
